function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  width: 100%;\n  background-color: var(--my-card-background);\n  color: var(--theme-text);\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  width: 50px;\n  height: 50px;\n  border: 5px solid rgba(0, 0, 0, 0.1);\n  border-radius: 50%;\n  border-top-color: var(--theme-primary);\n  animation: ",
        " 1s ease-in-out infinite;\n  margin-bottom: 1rem;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  font-size: 1.125rem;\n  font-weight: 500;\n  margin-top: 1rem;\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
import React from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
var spin = keyframes(_templateObject());
var LoadingContainer = styled.div(_templateObject1());
var Spinner = styled.div(_templateObject2(), spin);
var LoadingText = styled.p(_templateObject3());
/**
 * 페이지나 컨텐츠 로딩 중 표시되는 로딩 화면 컴포넌트
 */ var LoadingScreen = function(param) {
    var _param_message = param.message, message = _param_message === void 0 ? "로딩 중입니다..." : _param_message;
    return /*#__PURE__*/ React.createElement(LoadingContainer, null, /*#__PURE__*/ React.createElement(Spinner, null), /*#__PURE__*/ React.createElement(LoadingText, null, message));
};
export default LoadingScreen;
